exports.en = {
  EXT_ERROR_BACKEND: {
    ERR_GENERAL: 'Omlouváme se, nelze zobrazit obsah.',
    ERR_TOO_MANY_REDIRECTS: 'Nelze ověřit uživatele. Po chvíli se zkuste znovu přihlásit zde',
    ERR_ACCESS_DENIED: 'Nemáte přístup k obsahu.',
    EXT_ACCESS_MANAGER: 'Přihlášení pro externí partnery',
    INT_ACCESS_MANAGER: 'Přihlášení pro interní zaměstnance'
  }
}
